var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "AccountOutlined",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-account-outlined","viewBox":"0 0 500 500"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M278.089 500c-87.365 0-177.13-.211-266.694-.633H0l.8-11.814c.4-6.751 4.198-65.612 13.594-87.764 1.6-4.008 11.796-28.903 37.585-38.608l78.769-33.544 33.186-15.4c.6-.212 15.194-6.54 19.193-24.895.4-2.743.2-6.54-.2-7.595-1.8-3.587-1.8-3.587-6.198-8.86l-.2-.212c-1.4-1.688-32.587-40.717-39.784-97.046-.4-2.743-4.198-29.536-.6-61.182 4.999-44.936 22.192-78.059 49.98-95.78C187.326 15.823 213.716 0 251.1 0c21.79 0 42.982 5.485 62.974 16.034 7.197 3.375 67.773 35.02 51.18 159.282-.4 4.009-6.597 53.376-39.584 95.36-.8.843-1.6 1.898-2.6 3.164-1.599 1.898-3.798 4.22-4.997 6.329-.2 1.055-.6 3.797.4 6.962l.2.633.2.844c.2.422 3.398 15.611 22.59 24.472l42.983 20.464 63.375 26.794c1.4.632 39.184 16.455 47.181 68.987l.2 1.055L500 499.578h-11.395c-1-.21-80.768.422-210.516.422zM22.79 476.793c85.766.422 171.531.633 255.098.633 101.56 0 172.33-.422 198.72-.422l-2.998-44.726c-5.998-38.818-32.587-50.632-33.787-51.054l-64.174-27.005-42.983-20.464c-26.99-12.658-33.587-35.02-34.786-40.084-3.399-11.393-.2-20.886.2-21.941l.4-1.055c2.399-5.274 6.197-9.283 8.796-12.447.6-.844 1.4-1.477 1.8-2.11 29.388-37.342 34.785-83.122 34.785-83.755v-.211c14.795-110.549-36.385-134.6-38.584-135.654l-.8-.422c-16.993-9.072-34.986-13.713-53.578-13.713-31.588 0-53.779 13.291-53.979 13.502-53.778 34.388-39.184 133.122-39.184 134.177v.422c5.998 48.312 32.987 83.122 34.786 85.443 5.798 6.751 6.397 7.595 9.396 13.924 3.599 7.595 2.6 18.144 2.2 21.097l-.2.844c-5.998 29.325-28.989 40.085-32.188 41.561l-33.186 15.19-79.369 33.966c-17.992 6.752-24.99 25.528-24.99 25.739l-.4.844c-5.397 12.236-9.196 46.413-10.995 67.721z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/account-outlined.svg